import { QueryTreeNodeType, } from '../query-tree';
import QueryJobFill from './query-job-fill';
import QueryJobDistinct from './query-job-distinct';
import QueryJobFilter from './query-job-filter';
import QueryJobHydrate from './query-job-hydrate';
import QueryJobIndexScan from './query-job-index-scan';
import QueryJobIntersect from './query-job-intersect';
import QueryJobPaginate from './query-job-paginate';
import QueryJobScan from './query-job-scan';
import QueryJobSort from './query-job-sort';
import QueryJobUnion from './query-job-union';
export function createContext(node) {
    return {
        total: node.children.length,
        done: 0,
        inputs: [],
    };
}
export function createQueryJob(node, parent, transaction) {
    var _a;
    return (_a = {},
        _a[QueryTreeNodeType.FILL] = function () { return new QueryJobFill(node, parent); },
        _a[QueryTreeNodeType.DISTINCT] = function () { return new QueryJobDistinct(node, parent); },
        _a[QueryTreeNodeType.FILTER] = function () { return new QueryJobFilter(node, parent); },
        _a[QueryTreeNodeType.HYDRATE] = function () { return new QueryJobHydrate(node, parent, transaction); },
        _a[QueryTreeNodeType.INDEX_SCAN] = function () { return new QueryJobIndexScan(node, parent, transaction); },
        _a[QueryTreeNodeType.INTERSECT] = function () { return new QueryJobIntersect(node, parent); },
        _a[QueryTreeNodeType.PAGINATE] = function () { return new QueryJobPaginate(node, parent); },
        _a[QueryTreeNodeType.SCAN] = function () { return new QueryJobScan(node, parent, transaction); },
        _a[QueryTreeNodeType.SCAN_ALL] = function () { return new QueryJobScan(node, parent, transaction); },
        _a[QueryTreeNodeType.SORT] = function () { return new QueryJobSort(node, parent); },
        _a[QueryTreeNodeType.UNION] = function () { return new QueryJobUnion(node, parent); },
        _a)[node.type]();
}
//# sourceMappingURL=query-job.js.map